export default [{
  _name: 'CSidebarNav',
  _children: [{
      _name: 'CSidebarNavItem',
      name: 'Dashboard',
      to: '/dashboard',
      icon: 'cil-speedometer',
      badge: {
        color: 'primary',
        text: 'NEW'
      }
    },
    {
      _name: 'CSidebarNavTitle',
      _children: ['Transaksi']
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Order',
      to: '/order',
      icon: 'cil-stream',
    },
    {
      _name: 'CSidebarNavTitle',
      _children: ['Sistem']
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Master',
      route: '/master',
      icon: 'cil-line-weight',
      items: [{
          name: 'Program Studi',
          to: '/master/study-program'
        },
        {
          name: 'Kelompok Program Study',
          to: '/master/study-program-group'
        },
        {
          name: 'Mata Pelajaran Uji',
          to: '/master/subjects'
        },
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Mapping',
      route: '/mapping',
      icon: 'cil-vector',
      items: [{
          name: 'Program Studi - Jurusan',
          to: '/mapping/study-program/major'
        },
        {
          name: 'Simpangan Baku',
          to: '/mapping/standard-deviation'
        },
      ]
    },
    {
      _name: 'CSidebarNavDropdown',
      name: 'Soal',
      route: '/soal',
      icon: 'cil-library-add',
      items: [{
          name: 'Soal',
          to: '/soal/list'
        },
        {
          name: 'Seri Tryout',
          to: '/soal/series'
        },
      ]
    },
    {
      _name: 'CSidebarNavItem',
      name: 'User',
      to: '/user/list',
      icon: 'cil-group',
    },
    // {
    //   _name: 'CSidebarNavItem',
    //   name: 'Report',
    //   to: '/dashboard',
    //   icon: 'cil-library',
    // },
    {
      _name: 'CSidebarNavTitle',
      _children: ['Laporan']
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Hasil Ujian',
      to: '/exam-summary',
      icon: 'cil-library',
    },
    {
      _name: 'CSidebarNavTitle',
      _children: ['Tools']
    },
    {
      _name: 'CSidebarNavItem',
      name: 'Slider',
      to: '/slider',
      icon: 'cil-image-plus',
    },
  ]
}]